var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path5, _path6, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionMindBlowing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1328 35.0137L12.6328 30.0137L14.1328 28.0137L15.6328 31.5137L15.1328 35.0137Z",
    fill: "url(#paint0_linear_3003_69651)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8396 14.0499L20.4465 17.6073L18.5982 17.7389L20.3625 15.3779L22.8396 14.0499Z",
    fill: "url(#paint1_linear_3003_69651)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6328 24.0137L12.1328 21.7837L16.541 17.5137L15.1327 20.5143L16.5408 21.7837L15.6328 23.5137L12.6328 24.0137Z",
    fill: "url(#paint2_linear_3003_69651)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8928 28.033L62.4811 29.7126L61.8984 35.8652L60.5639 32.4663L57.9307 32.125L57.2605 30.1128L59.8928 28.033Z",
    fill: "url(#paint3_linear_3003_69651)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3003_69651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2867 29.5137H46.979V29.5137C46.8383 32.5267 47.2094 35.5418 48.0766 38.4307L48.1328 38.6182H40.6328H33.1328L33.1891 38.4307C34.0562 35.5418 34.4273 32.5267 34.2867 29.5137V29.5137Z",
    fill: "url(#paint4_linear_3003_69651)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dif_3003_69651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.1705,
    cy: 15.2762,
    rx: 4.8375,
    ry: 3.7625,
    fill: "#FBF2C3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dif_3003_69651)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.9703,
    cy: 24.9508,
    r: 4.8375,
    fill: "#FBF2C3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dif_3003_69651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.6328,
    cy: 17.5137,
    rx: 3.5,
    ry: 3,
    fill: "#FBF2C3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dif_3003_69651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.4701,
    cy: 18.5016,
    rx: 5.9125,
    ry: 4.8375,
    fill: "#FBF2C3"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dif_3003_69651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.7326,
    cy: 19.577,
    rx: 4.3,
    ry: 3.7625,
    fill: "#FBF2C3"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dif_3003_69651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7953,
    cy: 18.5016,
    rx: 5.9125,
    ry: 4.8375,
    fill: "#FBF2C3"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dif_3003_69651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.2201,
    cy: 22.8004,
    rx: 5.9125,
    ry: 4.8375,
    fill: "#FBF2C3"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dif_3003_69651)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.4957,
    cy: 24.9508,
    r: 4.8375,
    fill: "#FBF2C3"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_dif_3003_69651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.6205,
    cy: 25.5637,
    rx: 5.9125,
    ry: 4.3,
    fill: "#FBF2C3"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_dif_3003_69651)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.0951,
    cy: 27.1012,
    rx: 5.9125,
    ry: 4.8375,
    fill: "#FBF2C3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1328 33.0137L19.1328 37.5137L39.6328 63.5137L61.1328 38.0137L60.1328 36.0137L58.1328 37.5137L56.1328 34.0137L53.6328 35.0137L50.1328 33.0137L47.1328 36.5137L45.1328 35.0137L42.1328 35.5137L39.6328 39.0137L36.6328 32.0137L34.6328 39.5137L30.1328 32.5137L28.6328 33.5137L27.1328 32.0137H23.6328V36.0137L22.6328 33.5137L21.1328 33.0137Z",
    fill: "url(#paint5_linear_3003_69651)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3003_69651",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 33,
    width: 50,
    height: 35
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1328 35.0137L17.1328 40.5137L16.6328 60.0137L41.1328 67.0137L65.1328 57.5137L62.6328 38.5137L61.1328 37.0137L59.1328 37.5137L54.1328 34.0137L52.6328 35.0137L52.1328 33.5137L50.1328 35.0137L49.1328 34.0137L47.6328 35.0137L42.6328 37.5137L41.1328 36.0137L39.6328 38.5137L37.6328 37.5137L36.1328 38.5137L35.6328 36.0137H34.1328L33.6328 34.0137H32.1328L28.6328 37.5137L27.1328 36.0137L25.6328 37.0137L24.6328 35.5137L22.1328 34.0137L21.1328 40.0137L20.6328 35.0137H18.1328Z",
    fill: "#D9D9D9"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3003_69651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5928 42.0137C62.5928 54.4401 52.5192 64.5137 40.0928 64.5137C27.6664 64.5137 17.5928 54.4401 17.5928 42.0137C17.5928 29.5873 27.6664 19.5137 40.0928 19.5137C52.5192 19.5137 62.5928 29.5873 62.5928 42.0137Z",
    fill: "url(#paint6_linear_3003_69651)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter11_i_3003_69651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1328 43.5137C34.1328 45.1705 33.2374 46.5137 32.1328 46.5137C31.0282 46.5137 30.1328 45.1705 30.1328 43.5137C30.1328 41.8568 31.0282 40.5137 32.1328 40.5137C33.2374 40.5137 34.1328 41.8568 34.1328 43.5137Z",
    fill: "#262626"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter12_f_3003_69651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1328 43.5137C34.1328 45.1705 33.2374 46.5137 32.1328 46.5137C31.0282 46.5137 30.1328 45.1705 30.1328 43.5137C30.1328 41.8568 31.0282 40.5137 32.1328 40.5137C33.2374 40.5137 34.1328 41.8568 34.1328 43.5137Z",
    fill: "#FBF2C3"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter13_i_3003_69651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1328 43.5137C51.1328 45.1705 50.2374 46.5137 49.1328 46.5137C48.0282 46.5137 47.1328 45.1705 47.1328 43.5137C47.1328 41.8568 48.0282 40.5137 49.1328 40.5137C50.2374 40.5137 51.1328 41.8568 51.1328 43.5137Z",
    fill: "#262626"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter14_f_3003_69651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1328 43.5137C51.1328 45.1705 50.2374 46.5137 49.1328 46.5137C48.0282 46.5137 47.1328 45.1705 47.1328 43.5137C47.1328 41.8568 48.0282 40.5137 49.1328 40.5137C50.2374 40.5137 51.1328 41.8568 51.1328 43.5137Z",
    fill: "#FBF2C3"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter15_i_3003_69651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9757 50.4512C36.9623 50.4512 35.5807 52.6787 35.1703 54.5424C35.0216 55.218 35.7068 55.7177 36.3742 55.5356C37.5526 55.2139 39.3249 54.8228 40.9757 54.8228C42.6266 54.8228 44.3988 55.2139 45.5773 55.5356C46.2447 55.7177 46.9299 55.218 46.7812 54.5424C46.3708 52.6787 44.9892 50.4512 40.9757 50.4512Z",
    fill: "#262626"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter16_f_3003_69651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9757 50.4512C36.9623 50.4512 35.5807 52.6787 35.1703 54.5424C35.0216 55.218 35.7068 55.7177 36.3742 55.5356C37.5526 55.2139 39.3249 54.8228 40.9757 54.8228C42.6266 54.8228 44.3988 55.2139 45.5773 55.5356C46.2447 55.7177 46.9299 55.218 46.7812 54.5424C46.3708 52.6787 44.9892 50.4512 40.9757 50.4512Z",
    fill: "#FBF2C3"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5299 17.6787L46.7197 11.649L49.8426 12.2722L50.065 16.1894L47.5299 17.6787Z",
    fill: "url(#paint7_linear_3003_69651)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5282 26.3247L54.0604 24.215L55.9529 30.1465L50.5596 30.8524L49.1163 33.2624L48.1458 26.5693L50.5282 26.3247Z",
    fill: "url(#paint8_linear_3003_69651)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3003_69651",
    x: 33.1328,
    y: 29.5137,
    width: 15,
    height: 12.1035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.983333 0 0 0 0 0.947141 0 0 0 0 0.766181 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dif_3003_69651",
    x: 33.333,
    y: 10.5137,
    width: 13.6748,
    height: 11.5254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.681617 0 0 0 0 0.766927 0 0 0 0 0.608073 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69651",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807273 0 0 0 0 0.925 0 0 0 0 0.709167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect3_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dif_3003_69651",
    x: 16.1328,
    y: 19.1133,
    width: 13.6748,
    height: 13.6758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.681617 0 0 0 0 0.766927 0 0 0 0 0.608073 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69651",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807273 0 0 0 0 0.925 0 0 0 0 0.709167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect3_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dif_3003_69651",
    x: 46.1328,
    y: 13.5137,
    width: 11,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.681617 0 0 0 0 0.766927 0 0 0 0 0.608073 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69651",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807273 0 0 0 0 0.925 0 0 0 0 0.709167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect3_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dif_3003_69651",
    x: 36.5576,
    y: 12.6641,
    width: 15.8252,
    height: 13.6758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.681617 0 0 0 0 0.766927 0 0 0 0 0.608073 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69651",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807273 0 0 0 0 0.925 0 0 0 0 0.709167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect3_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dif_3003_69651",
    x: 20.4326,
    y: 14.8145,
    width: 12.5996,
    height: 11.5254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.681617 0 0 0 0 0.766927 0 0 0 0 0.608073 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69651",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807273 0 0 0 0 0.925 0 0 0 0 0.709167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect3_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dif_3003_69651",
    x: 26.8828,
    y: 12.6641,
    width: 15.8252,
    height: 13.6758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.681617 0 0 0 0 0.766927 0 0 0 0 0.608073 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69651",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807273 0 0 0 0 0.925 0 0 0 0 0.709167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect3_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dif_3003_69651",
    x: 47.3076,
    y: 16.9629,
    width: 15.8252,
    height: 13.6758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.681617 0 0 0 0 0.766927 0 0 0 0 0.608073 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69651",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807273 0 0 0 0 0.925 0 0 0 0 0.709167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect3_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dif_3003_69651",
    x: 23.6582,
    y: 19.1133,
    width: 13.6748,
    height: 13.6758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.681617 0 0 0 0 0.766927 0 0 0 0 0.608073 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69651",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807273 0 0 0 0 0.925 0 0 0 0 0.709167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect3_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_dif_3003_69651",
    x: 38.708,
    y: 20.2637,
    width: 15.8252,
    height: 12.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.681617 0 0 0 0 0.766927 0 0 0 0 0.608073 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69651",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807273 0 0 0 0 0.925 0 0 0 0 0.709167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect3_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_dif_3003_69651",
    x: 31.1826,
    y: 21.2637,
    width: 15.8252,
    height: 13.6758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.681617 0 0 0 0 0.766927 0 0 0 0 0.608073 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_69651",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807273 0 0 0 0 0.925 0 0 0 0 0.709167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3003_69651"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect3_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_3003_69651",
    x: 30.1328,
    y: 40.5137,
    width: 4,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_3003_69651",
    x: 23.1328,
    y: 33.5137,
    width: 18,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_3003_69651",
    x: 47.1328,
    y: 40.5137,
    width: 4,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_3003_69651",
    x: 40.1328,
    y: 33.5137,
    width: 18,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_3003_69651",
    x: 35.1494,
    y: 50.4512,
    width: 11.6523,
    height: 5.12305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3003_69651"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_3003_69651",
    x: 28.1494,
    y: 43.4512,
    width: 25.6523,
    height: 19.123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_3003_69651"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3003_69651",
    x1: 14.1328,
    y1: 28.0137,
    x2: 14.1328,
    y2: 35.0137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3003_69651",
    x1: 18.5982,
    y1: 17.7389,
    x2: 23.196,
    y2: 14.5665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3003_69651",
    x1: 17.8202,
    y1: 19.1948,
    x2: 12.2127,
    y2: 23.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3003_69651",
    x1: 59.0158,
    y1: 35.0928,
    x2: 60.8395,
    y2: 28.2867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3003_69651",
    x1: 40.6328,
    y1: 29.5137,
    x2: 40.6328,
    y2: 38.6182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3003_69651",
    x1: 40.1328,
    y1: 32.0137,
    x2: 40.1328,
    y2: 63.5137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3003_69651",
    x1: 40.0928,
    y1: 19.5137,
    x2: 40.0928,
    y2: 64.5137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3003_69651",
    x1: 49.8426,
    y1: 12.2722,
    x2: 46.1511,
    y2: 16.4647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3003_69651",
    x1: 52.5172,
    y1: 32.9132,
    x2: 51.6493,
    y2: 24.4626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionMindBlowing);
export default __webpack_public_path__ + "static/media/reaction_mind-blowing.00f57ede77cafa95467dfb39e768ef65.svg";
export { ForwardRef as ReactComponent };